<template>
  <div class="container ">
    <el-breadcrumb
      separator="/"
      style="padding-bottom: 16px; font-size: 20px; padding: 15px;"
    >
      <el-breadcrumb-item v-for="path in paths">
        <a @click="backToFolder(path)"><i :class="path.icon" /> {{ path.nome_pasta }}</a>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <ul
      v-for="item of pastas"
      :key="item.id"
      class="players___26VY9 hvr-glow "
    >
      <li
        class="player-card___2Fvfg"
        draggable="true"
        style="opacity: 1;"
        @click="getFolder(item)"
      >
        <!--        <button @click.stop class="player-card&#45;&#45;checkbox___27L9W">-->
        <!--          <label class="ant-checkbox-wrapper content&#45;&#45;zindex">-->
        <!--            <span class="ant-checkbox">-->
        <!--              <input type="checkbox" class="ant-checkbox-input" value="" id="check1"-->
        <!--                name="check1"   @change="handleChecked(item)" v-model="item.is_selected" :true-value="true" :false-value="false">-->
        <!--            </span>-->
        <!--          </label>-->
        <!--        </button>-->
        <div
          class="ant-row ant-row-no-wrap ant-row-middle player-card--content___D1qZG"
          style="row-gap: 0px;"
        >
          <div
            class="ant-col player-card--thumb___35WZM"
            style="flex: 1 1 auto; min-width: 0px;"
          >
            <div class="player-card-thumb-name___2WjVQ">
              <div class="folder-thumb-name--folder___3VtKS">
                <span
                  role="img"
                  aria-label="folder"
                  class="anticon anticon-folder"
                >
                  <folder />
                </span>
              </div>
              <div class="player-card-thumb-name--info___21UGr">
                <div class="player-card-name___2r4hW">
                  <strong :id="'strong' + item.id">{{ item.nome_pasta }}</strong>
                </div>
                <div class="player-card-thumb-name--info_date___97-MJ"><span
                  class="ant-typography ant-typography-ellipsis ant-typography-single-line ant-typography-ellipsis-single-line"
                >{{
                  item.data_pasta
                }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="ant-col player-card--info___1ux6J "
            style="flex: 1 1 auto; min-width: 0px;"
          >
            <a
              class="player-card-views___sZ32Z"
              href="#"
            />

          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'
import { useApi } from '@/composables/useApi'
// eslint-disable-next-line import/extensions
import { PastaService } from '@/services/Pasta.js'
import { mapActions, mapState } from 'vuex'
// const apiAWS = useApiAWS()
import {
  BButton, BFormGroup, BFormInput, BModal, VBModal, BCardText, BListGroup, BListGroupItem, BAlert, BLink, BCard,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import { codePrevent } from '@/views/App/Pastas/code copy'
import Folder from '@/assets/images/folder/folder.vue'
import crypto from 'crypto'
import { UploadFilesService } from '@/services/UploadFiles'

const api = useApi()

export default {
  components: {
    BCardCode,
    BButton,
    BFormGroup,
    BCardText,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,
    BAlert,
    BLink,
    BCard,
    Folder,
  },
  props: ['value'],
  computed: {
    ...mapState('Pastas', ['pastaAtual']),
    pastas: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
  },
  name: 'Modal',
  directives: {
    'b-modal': VBModal,

    Ripple,
  },
  data() {
    return {
      input: '',
      loading: false,
      paths: [],
      id_conteudo: localStorage.getItem('uidConteudo'),
      outerVisible: false,
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3,
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      contentWidth: this.$store.state.appConfig.layout.contentWidth,
      userData: JSON.parse(localStorage.getItem('userData')),
      errorMessage: null,
      codePrevent,
      pastaAws: {
        nome_pasta: '',
      },
      nameState: null,
      checkFile: false,
      IdPasta: '',
      pastaATUAL: {},
    }
  },

  methods: {
    ...mapActions('Pastas', ['getAllPastaUser']),
    // ...mapActions('Videos', ['listarVideos']),
    // handleChecked(item) {
    //   this.$emit('selectVideoFolder', item)
    // },
    openFileInput() {
      this.$refs.fileInput.click()
    },
    async handleFileChange(event) {
      const selectedFile = event.target.files[0]
      const uid = Math.floor(Math.random() * 1000000000000).toString().padStart(13, '0')
      if (selectedFile) {
        // Verificar a extensão do arquivo para garantir que não é um arquivo MP4 ou MP3
        const disallowedExtensions = ['.mp4', '.mp3']
        const fileExtension = selectedFile.name.split('.').pop().toLowerCase()

        if (!disallowedExtensions.includes(fileExtension)) {
          const formData = new FormData()
          const caminho = `${this.userData.user_file_key}Upload_Files/`
          formData.append('file', selectedFile)
          formData.append('caminho', caminho)
          await axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/UploadArquivos`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }).then(async response => {
            const pastaAtual = JSON.parse(localStorage.getItem('pastaATUAL'))
            this.pastaATUAL = pastaAtual
            if (this.pastaATUAL === 0) {
              var idPASTA = 0
            } else {
              var idPASTA = this.pastaATUAL.id
            }
            await api.post('/creatFiles', {
              id_conteudo: localStorage.getItem('uidConteudo'),
              file_name: response.data.data.fileNameOrigin,
              file_bucket_address: response.data.data.fileUrl,
              file_key_name: response.data.data.key_filename,
              file_type: response.data.data.file_type,
              id_user: this.getUserData.id,
              file_uid: uid,
              file_id_pasta: idPASTA,
            })
              .then(() => {
                if (this.pastaATUAL === 0) {
                  this.getPastaAll(0)
                  this.$emit('updateArquivos', { id: 0 })
                } else {
                  this.getPastaAll(this.pastaATUAL.id)
                  this.$emit('updateArquivos', JSON.parse(localStorage.getItem('pastaATUAL')))
                }
                this.$message({
                  type: 'success',
                  message: 'Salvo com sucesso',
                })
              })
              .catch(err => console.error(err))
          })
          console.log('Arquivo selecionado:', selectedFile.name)
        } else {
          console.log('Tipo de arquivo não permitido.')
        }
      }
    },
    async getFolder(item) {
      console.log(item)
      this.loading = true
      this.$store.commit('Pastas/setCurrentPastaId', item.id)
      this.$store.commit('Pastas/setpastaAtual', item)
      localStorage.setItem('pastaATUAL', JSON.stringify(item))
      this.$emit('updateArquivos', item)
      console.log('Passou')
      this.getAllPastaUser()
      this.getPastaAll(item.id)
      this.IdPasta = item
      if (this.paths.length === 0) {
        this.paths.push({
          nome_pasta: 'Meus Arquivos',
          icon: 'fi fi-bs-video-camera',
          id: 0,
        })
      }
      const res = this.paths.find(f => f.id === item.id)
      if (res === undefined) {
        this.paths.push(item)
      }

      this.$store.commit('Pastas/setIdMainParams', item.id)
      await this.$store.dispatch('Pastas/getAllPastaUser')
        .finally(() => {
          this.loading = false
        })
    },

    async getPastaAll(id_folder) {
      console.log(localStorage.getItem('uidConteudo'))
      await api.get(`/pastaUser?id_main=${id_folder}&id_conteudo=${this.id_conteudo}`, {
      })
        .then(resp => {
          console.log(resp)
          const formData = resp.data
          formData.map(v => v.is_selected = false)
          this.pastas = formData
          this.$store.commit('Pastas/setAllPastaMain', formData)
        })
    },
    // async getArquivoAll(id_folder) {
    //   const params = {
    //     id_main: id_folder,
    //     id_conteudo: this.id_conteudo,
    //   }
    //   await api.get('/arquivoUser', {
    //     params,
    //   })
    //     .then(resp => {
    //       console.log(resp)
    //       const formData = resp.data
    //       formData.map(v => v.is_selected = false)
    //       this.pastas = formData
    //       this.$store.commit('Pastas/setAllPastaMain', formData)
    //     })
    // },
    async deleteFolder(folder) {
      console.log(folder)
      await api.delete(`/deletePasta?id=${folder.id}`)
        .then(async () => {
          console.log(this.pastaATUAL)
          this.getPastaAll(folder.id_main)
          this.$message({
            type: 'success',
            message: 'Deletado com sucesso',
          })
          await this.$store.dispatch('Pastas/getAllPastaUser')
            .finally(() => {
              this.loading = false
            })
        })
        .catch(err => console.error(err))
    },

    deletarPastaAWS(item) {
      const options = {
        method: 'DELETE',
        url: `${this.VUE_APP_HOST_API_AWS_S3}`,
        params: {
          key: item,
          delete: '',
        },
      }

      axios.request(options).then(response => {
      }).catch(error => {
        console.error(error)
      })
    },

    open(item) {
      console.log('PASTA A SER DELETADA', item)
      //  this.folderATUAL = item;
      this.$confirm('Você tem certeza que deseja deletar a pasta? Se sim, todos os dados e arquivos serão removidos.', 'Deletar Pasta', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'Deletar pasta',
      }).then(res => {
        if (res) {
          this.deleteFolder(item)
        }

        this.$message({
          type: 'success',
          message: 'Deletado com sucesso',
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete cancelado',
        })
      })
    },

    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.name = valid
      return valid
    },
    resetModal() {
      this.pastaAws.folder_name = ''
      this.nameState = null
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleSubmit()
    },
    async idfolderAtual() {
      const pastaAtual = JSON.parse(localStorage.getItem('pastaATUAL'))
      console.log('PASTAATUAL', pastaAtual)
      this.pastaATUAL = pastaAtual
    },
    handleSubmit() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/criarPasta`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"nome_pasta":"${this.pastaAws.nome_pasta.replace(/(\r\n|\n|\r)/gm, '')
        }","endereco_aws_pasta":"","id_main":"${this.pastaATUAL.id
        }","uid_conteudo":"${this.id_conteudo}",
        "chave_aws_pasta":"","id_user":"${this.userData.id}"}`,
      })
        .then(async response => {
          if (this.pastaATUAL === 0) {
            this.getPastaAll(0)
          } else {
            this.getPastaAll(this.pastaATUAL.id)
          }

          await this.$store.dispatch('Pastas/getAllPastaUser')
            .finally(() => {
              this.loading = false
            })
          this.$notify({
            title: 'Success',
            message: 'Pasta criada com sucesso.',
            type: 'success',
          })
        })
        .catch(err => console.error(err))

      if (!this.checkFormValidity()) {
        return
      }
      this.pastas.push(this.folder)
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },

    // CriarPasta() {
    //   const crypto = require('crypto')
    //   const results = this.pastaAws.nome_pasta
    //
    //   const hash = crypto.createHash('sha256')
    //     .update(results.toString())
    //     .digest('hex')
    //
    //   const NameFoldeHash = hash.substring(0, 30)
    //
    //   if (this.pastaATUAL === 0) {
    //     this.caminhoPasta = `${this.userData.user_file_key}UploadFolderVideos/`
    //   } else {
    //     this.caminhoPasta = this.folderATUAL.folder_key_name
    //   }
    //
    //   fetch(`${this.VUE_APP_HOST_API_AWS_S3}/create?caminho=${this.caminhoPasta}${NameFoldeHash}/`, {
    //     method: 'POST',
    //   })
    //     .then(res => res.json())
    //     .then(res => {
    //       this.Url_pasta = res.fileUrl
    //       this.key_name = res.file_key
    //
    //       if (res.status == 201) {
    //         this.handleSubmit()
    //         if (res) {
    //
    //           // this.getFoldersAll(this.IdPasta);
    //         }
    //       }
    //     })
    //     .catch(error => {
    //       this.$notify.error({
    //         title: 'Error',
    //         message: `Esta é uma mensagem de erro: ${error}`,
    //       })
    //     })
    // },

    async cancelMoverFolder() {
      this.outerVisible = false
      this.paths = []
      this.loading = true
      this.$store.commit('Folders/setIdMainParams', 0)
      await this.$store.dispatch('Folders/getAllFolderUser')
        .finally(() => {
          this.loading = false
        })
    },
    async backToFolder(item) {
      console.log(item.id)
      if (item.id === 0) {
        localStorage.setItem('pastaATUAL', JSON.stringify(item.id))
      } else {
        localStorage.setItem('pastaATUAL', JSON.stringify(item))
      }
      this.loading = true
      const indexItem = this.paths.indexOf(item)
      // this.$emit('updateVideos', item)
      this.paths.forEach((p, i) => {
        if (i > indexItem) {
          this.paths.splice(i, 1)
        }
      })
      if (item.id || item.id === 0) {
        // this.clearFolder()
      }
      this.$emit('updateArquivos', item)
      this.getPastaAll(item.id)
    },
    clearFolder() {
      this.$store.commit('Pastas/setpastaAtual', {
        id: 0,
        folder_name: null,
        folder_backet_adress: null,
        id_main: null,
        id_user: null,
        folder_date: null,
        folder_key_name: null,
      })
    },
    aparecerEdição(item) {
      const strong = document.getElementById(`strong${item}`)
      const input = document.getElementById(`input${item}`)
      const botaosalvar = document.getElementById(`botao-salvar${item}`)
      const iconeeditar = document.getElementById(`icone-editar${item}`)
      strong.setAttribute('hidden', '')
      iconeeditar.setAttribute('hidden', '')
      botaosalvar.removeAttribute('hidden')
      input.removeAttribute('hidden')
    },
    async salvarEdicão(item) {
      console.log('ITEM', item)
      await api.put('/editNomePasta', {
        nome_pasta: item.nome_pasta,
        id: item.id,
      })
        .then(() => {
          const strong = document.getElementById(`strong${item.id}`)
          const input = document.getElementById(`input${item.id}`)
          const botaosalvar = document.getElementById(`botao-salvar${item.id}`)
          const iconeeditar = document.getElementById(`icone-editar${item.id}`)
          input.setAttribute('hidden', '')
          botaosalvar.setAttribute('hidden', '')
          iconeeditar.removeAttribute('hidden')
          strong.removeAttribute('hidden')
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
  },
}
</script>
<style lang="scss" scoped>

.hvr-glow {

  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: box-shadow;
  transition-property: box-shadow;
}

.hvr-glow:hover,
.hvr-glow:focus,
.hvr-glow:active {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.407);
}

.players___26VY9 {
  margin-top: .5rem;
  padding: 0;
  overflow: unset !important;
}

.player-card___2Fvfg {
  display: flex;
  background: #fff;
  border: .0625rem solid #ebebeb;
  border-radius: 4px;
  list-style: none;
  height: 7.125rem;
  transition: box-shadow .4s;
}

.player-card___2Fvfg .player-card--checkbox___27L9W {
  padding: 1rem;
  background: transparent;
  border: none;
  cursor: pointer;
}

.player-card___2Fvfg .player-card--content___D1qZG {
  padding: 1rem 1rem 1rem 0;
  position: relative;
  width: calc(100% - 3.25rem);
}

.ant-row-middle {
  align-items: center;
}

.ant-row-no-wrap {
  flex-wrap: nowrap;
}

.ant-row {
  display: flex;
  flex-flow: row wrap;
}

.player-card___2Fvfg .content--zindex {
  z-index: 2;
}

/* chackbox*/

.ant-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}

.ant-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  position: relative;
  top: .2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}

.ant-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 20px;
  height: 20px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  border-collapse: separate;
  transition: all .3s;
}

/*card*/
.player-card___2Fvfg .player-card--content___D1qZG {
  padding: 1rem 1rem 1rem 0;
  position: relative;
  width: calc(100% - 3.25rem);
}

.ant-row-middle {
  align-items: center;
}

.ant-row-no-wrap {
  flex-wrap: nowrap;
}

.ant-row {
  display: flex;
  flex-flow: row wrap;
}

.player-card___2Fvfg .player-card--thumb___35WZM {
  display: flex;
  align-items: center;
}

.ant-col {
  position: relative;
  max-width: 100%;
  min-height: 1px;
}

.player-card-thumb-name___2WjVQ {
  display: flex;
  align-items: center;
  margin-right: 1rem;
  width: 100%;
}

.player-card-thumb___361GV {
  min-width: 8rem;
  width: 8rem;
  height: 5rem;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  z-index: 2;
}

.player-card-thumb-name___2WjVQ .player-card-thumb-name--info___21UGr {
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  width: calc(100% - 11.25rem);
}

.player-card-thumb___Erlrt {
  position: relative;
}

.player-card-thumb___Erlrt .player-card-thumb--image___1cZXg {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

img {
  vertical-align: middle;
  border-style: none;
}

.player-card-thumb___Erlrt .player-card-thumb--duration-tag___38VC6 {
  position: absolute;
  bottom: .25rem;
  right: .25rem;
  background: #262626;
  border: none;
  border-radius: 4px;
  padding: .125rem .25rem;
  margin: 0;
  font-weight: 500;
  font-size: .625rem;
  line-height: .75rem;
  color: #fff;
}

.ant-tag,
.ant-tag a,
.ant-tag a:hover {
  color: rgba(0, 0, 0, .85);
}

.ant-tag {
  box-sizing: border-box;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  display: inline-block;
  height: auto;
  margin: 0 8px 0 0;
  padding: 0 7px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  opacity: 1;
  transition: all .3s;
}

.player-card-thumb___Erlrt .player-card-thumb--play___1GcpI {
  opacity: 0;
  background: rgba(0, 0, 0, .32);
  transition: opacity .4s;
  position: absolute;
  cursor: pointer;

}
.player-card-thumb___Erlrt:hover .player-card-thumb--play___1GcpI,
.player-card-thumb___Erlrt:focus .player-card-thumb--play___1GcpI {
  opacity: 1;
}
.player-card-thumb___Erlrt:hover .player-card-thumb--duration-tag___38VC6 {
  display: none;
}
.player-card-thumb___Erlrt,
.player-card-thumb___Erlrt .player-card-thumb--play___1GcpI {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.player-card-thumb___Erlrt .player-card-thumb--play___1GcpI svg {
  height: 1.5rem;
}

.player-card-thumb-name___2WjVQ .player-card-thumb-name--info___21UGr {
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  width: calc(100% - 11.25rem);
}

.player-card-name___2r4hW {
  display: flex !important;
  align-items: center;
}

.player-card-name___2r4hW>strong {
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 2;
}

.player-card-name___2r4hW .ant-spin,
.player-card-name___2r4hW .anticon {
  display: flex;
  margin-left: .625rem;
  z-index: 2;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon[tabindex] {
  cursor: pointer;
}

.player-card-thumb-name___2WjVQ .player-card-thumb-name--info___21UGr .player-card-thumb-name--info_date___97-MJ {
  display: flex;
  margin: .25rem 0;
}

.player-card-thumb-name___2WjVQ .player-card-thumb-name--info___21UGr .player-card-thumb-name--info_date___97-MJ span {
  font-size: .875rem;
  line-height: 1.375rem;
  color: #595959;
  z-index: 2;
}

a.ant-typography-ellipsis-single-line,
span.ant-typography-ellipsis-single-line {
  vertical-align: bottom;
}

a.ant-typography-ellipsis,
span.ant-typography-ellipsis {
  display: inline-block;
  max-width: 100%;
}

.ant-typography-ellipsis-single-line {
  overflow: hidden;
  text-overflow: ellipsis;
}

.ant-typography-single-line {
  white-space: nowrap;
}

.ant-typography {
  color: rgba(0, 0, 0, .85);
  overflow-wrap: break-word;
}

.player-card___2Fvfg .player-card--info___1ux6J {
  justify-content: flex-end;
  padding-left: 1.5rem;
  min-width: auto !important;
}

.player-card___2Fvfg .player-card--info___1ux6J,
.player-card___2Fvfg .player-card--thumb___35WZM {
  display: flex;
  align-items: center;
}

.ant-col {
  position: relative;
  max-width: 100%;
  min-height: 1px;
}

.player-card-views___sZ32Z {
  cursor: pointer;
  z-index: 2;
}

.player-card-views___sZ32Z span {
  border: none;
  border-radius: .5rem;
  transition: background .4s, border-color .4s, color .4s;
  margin: 0;
}

.ant-tag-blue {
  color: #096dd9;
  background: #e6f7ff;
  border-color: #91d5ff;
}

.ant-tag,
.ant-tag a,
.ant-tag a:hover {
  color: rgba(0, 0, 0, .85);
}

.ant-tag {
  box-sizing: border-box;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  display: inline-block;
  height: auto;
  margin: 0 8px 0 0;
  padding: 0 7px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  opacity: 1;
  transition: all .3s;
}

.player-card___2Fvfg .player-card--info___1ux6J>*+* {
  margin-left: .5rem;
}

.player-card-embed___3e5aX {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  border-radius: 4px;
  font-size: 0;
  padding: 0;
  transition: background .4s, border .4s;
  cursor: pointer;
  z-index: 2;
}

.player-card-embed___3e5aX svg {
  height: 1.25rem;
}

.player-card___2Fvfg .player-card--info___1ux6J>*+* {
  margin-left: .5rem;
}

.player-card___2Fvfg .player-card--details_link___imUBL {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  border-radius: 4px;
  z-index: 1;
}
.align-self-center {
  align-self: center !important;
}

.player-card-thumb-name___2WjVQ .folder-thumb-name--folder___3VtKS {
  min-width: 9rem;
  text-align: center;
}
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
